import { ADMIN_ROLES } from '../../config/adminAccess';

export const canManageInvitePolicy = (role) => role === ADMIN_ROLES.SUPER_ADMIN;

export const rateDurationValidationError = (ratePercent, durationDays) => (
  ratePercent > 0 && !(durationDays > 0)
    ? '提升比例大于0时，有效期必须大于0'
    : null
);

export const memberCapValidationError = (perInviteDays, monthlyCapDays) => (
  perInviteDays != null && monthlyCapDays != null && monthlyCapDays < perInviteDays
    ? '每月上限不能小于单次奖励'
    : null
);

export const toInvitePolicyFormValues = (policy) => ({
  ...policy,
  ratePerInvitePercent: Number(policy.ratePerInvite) * 100,
});

export const toInvitePolicyPayload = (values) => ({
  newUserBenefitDays: values.newUserBenefitDays,
  inviteeExtraBenefitDays: values.inviteeExtraBenefitDays,
  ratePerInvite: Number((values.ratePerInvitePercent / 100).toFixed(4)),
  rateBenefitDays: values.rateBenefitDays,
  capExtendDays: values.capExtendDays,
  firstOrderMinAmount: values.firstOrderMinAmount,
  memberExtendDays: values.memberExtendDays,
  memberMaxExtendDaysPerMonth: values.memberMaxExtendDaysPerMonth,
});
